export default {"src":"/_next/static/media/nautilus.4d7ec9e6.svg","height":54,"width":240,"blurWidth":0,"blurHeight":0};